<template lang="pug">
#product_combo
  cards-slider(
    :cards="homeIndex.area02_PackageList",
    :selectedIndex.sync="currentSelectIndex"
  )
  .description
    section.main.container.i_pt_10
      .row
        .col-12.d-flex.align-items-center.flex-column.flex-md-row.justify-content-between
          .title.text-center.text-md-left
            h2.i_h2_title {{ currentSelectCard.area01_Title }}
            h4.i_mt_sm_2 {{ currentSelectCard.area01_SubTitle }}
          img.i_ml_6.i_ml_md_10.i_ml_sm_0.i_mt_sm_4(
            :src="currentSelectCard.area01_Image"
          )
      .row
        .col-12
          p.i_body_l.i_mt_6.i_mt__md_8 {{ currentSelectCard.area01_Content }}
    .container-fluid.sub
      section.sub.container.i_pt_12
        .row
          .col-12
            h2.i_h2 {{ currentSelectCard.area02_Title }}
        .row.desc
          .col-12.position-relative.i_mt_md_7
            img.float-right(:src="currentSelectCard.area02_Image")
            .content.float-left
              p.i_body_l {{ currentSelectCard.area02_Content }}
    .container-fluid.sub.bg_light_blue
      section.container
        .row
          .col-12.text-center
            h2.i_h2_title {{ currentSelectCard.area03_Title }}
            p.i_body_l.subtitle {{ currentSelectCard.area03_Brief }}
        .row.title.i_mt_12.i_mt_md_8
          .col-12
            h2.i_h2.text-center.text-md-right {{ currentSelectCard.area03_SubTitle }}
        .row.desc.i_mt_md_4
          .col-12.position-relative
            img.float-left.float-left(:src="currentSelectCard.area03_Image")
            .content.float-right
              p.i_body_l {{ currentSelectCard.area03_Content }}
    section.recommend.container
      .row
        .col-12.text-center
          h2.i_h2_title {{ currentSelectCard.area04_Title }}
          p.i_body_l.subtitle {{ currentSelectCard.area04_SubTitle }}
      .row.i_mt_4
        nav.top_tab.d-flex
          nav-tab(
            v-for="(tab, index) in currentSelectCard.area04_ProductList",
            :title="tab.Type",
            :key="index",
            :selected="selectedLink == index",
            @click.native="changeTab(index)"
          )
      .row.i_mt_10
        .col-md-6.i_mb_9.i_mb_md_7.i_mb_sm_8(
          v-for="(item, index) in currentTypeList",
          :key="index"
        )
          item(:item="item")
    custom-footer
</template>

<script>
import NavTab from "@/components/customer_service/NavTab";
import Footer from "@/components/common/Footer";
import Item from "@/components/product_combo/recommend/Item";
import CardsSlider from "@/components/product_combo/CardsSlider";
import { getHomeIndex } from "@/json/home";
import { getCombinationList } from "@/json/product";

export default {
  name: "ProductCombo",
  components: {
    CardsSlider,
    NavTab,
    Item,
    "custom-footer": Footer,
  },
  data() {
    return {
      selectedLink: 0,

      homeIndex: {},
      combinationList: [],
      currentSelectCard: {
        area04_ProductList: [],
      },
      currentSelectIndex: 0,

      currentTypeList: [],
    };
  },
  watch: {
    currentSelectIndex() {
      this.getCurrentSelectCard();
    },
  },
  created() {
    this.getHomeIndex();
  },
  methods: {
    changeTab(index) {
      this.selectedLink = index;

      if (this.currentSelectCard.area04_ProductList[index]) {
        this.currentTypeList = this.currentSelectCard.area04_ProductList[
          index
        ].TypeList;
      }
    },
    getHomeIndex() {
      getHomeIndex().then((response) => {
        this.homeIndex = response.data;

        if (this.$route.params.id) {
          for (let index in this.homeIndex.area02_PackageList) {
            let temp = this.homeIndex.area02_PackageList[index];
            if (this.$route.params.id == temp.area02_PackageList_ID) {
              this.currentSelectIndex = parseInt(index);
            }
          }
        }

        this.getCombinationList();
      });
    },
    getCombinationList() {
      getCombinationList().then((response) => {
        this.combinationList = response.data.CombinationList;
        this.getCurrentSelectCard();
      });
    },
    getCurrentSelectCard() {
      let selectedID = this.homeIndex.area02_PackageList[
        this.currentSelectIndex
      ].area02_PackageList_ID;

      for (let index in this.combinationList) {
        let temp = this.combinationList[index];
        if (temp.ID == selectedID) {
          this.currentSelectCard = temp;
          break;
        }
      }
      this.changeTab(0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product_combo/product_combo";
</style>
